import { logAction, inferAction } from "action-logger";
import { LP } from "routes";
import { analytics, membershipLens } from "rtr-constants";
import { redirectToRoute } from "actions/action-utils";

// At the moment this component is only intended for use in the split the business (non-sub) experience.
//  It is not related to the acquisition messaging files in this folder which are used in the old upsell container.

export const handleMembershipAcquisitionCTAClick = (objectType, destination = LP.memberships) => {
  const destinationAppendLens = `${destination}?lens=${membershipLens.unlimited}`;
  inferAction({
    object_type: objectType,
    action: analytics.ACTION_TYPE.CLICK_TO_PLANS,
    destination_url: destinationAppendLens,
  });

  redirectToRoute(destinationAppendLens);
};

export const handleReserveAcquisitionCTAClick = (objectType, handleWayfindCtaClick) => {
  logAction({
    object_type: objectType,
    action: analytics.ACTION_TYPE.SWITCH_TO_RESERVE_LENS,
  });

  if (handleWayfindCtaClick) {
    handleWayfindCtaClick(membershipLens.classic);
  }
};

export default {
  handleMembershipAcquisitionCTAClick,
  handleReserveAcquisitionCTAClick,
};
